import * as type from "../types/authentication";

const initialState = {
  regularLoginStatus: null,
  regularLoginLoading: false,
  regularLoginError: null,
  regularLoginAction: null,
  googleLoginStatus: null,
  googleLoginLoading: false,
  googleLoginError: null,
  googleLoginAction: null,
};

export const authentication = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_REGULAR_LOGIN:
      return {
        ...state,
        regularLoginStatus: null,
        regularLoginLoading: true,
        regularLoginError: null,
        regularLoginAction: null,
      };
    case type.REVOKE_REGULAR_LOGIN:
      return {
        ...state,
        regularLoginStatus: null,
        regularLoginLoading: false,
        regularLoginError: payload.message,
      };
    case type.GRANT_REGULAR_LOGIN:
      return {
        ...state,
        regularLoginStatus: "success",
        regularLoginLoading: false,
        regularLoginError: null,
      };
    case type.RESET_REGULAR_LOGIN:
      return {
        ...state,
        regularLoginStatus: null,
        regularLoginLoading: false,
        regularLoginError: null,
      };
    case type.REQUEST_GOOGLE_LOGIN:
      return {
        ...state,
        googleLoginStatus: null,
        googleLoginLoading: true,
        googleLoginError: null,
        googleLoginAction: null,
      };
    case type.REVOKE_GOOGLE_LOGIN:
      return {
        ...state,
        googleLoginStatus: null,
        googleLoginLoading: false,
        googleLoginError: payload.message,
        googleLoginAction: null,
      };
    case type.GRANT_GOOGLE_LOGIN:
      return {
        ...state,
        googleLoginStatus: "success",
        googleLoginLoading: false,
        googleLoginError: null,
        googleLoginAction: payload.details.destination,
      };
    case type.RESET_GOOGLE_LOGIN:
      return {
        ...state,
        googleLoginStatus: null,
        googleLoginLoading: false,
        googleLoginError: null,
        googleLoginAction: null,
      };
    default:
      return state;
  }
};
